<template>
	<div>
		<el-container class="index-con">
			<el-aside width="200px" class="elAside">
				<el-menu
					:default-openeds="['1', '2', '3']"
					:default-active="indexss"
					ref="elMenu"
				>
					<el-submenu index="1">
						<template slot="title">资产管理</template>
						<el-menu-item-group>
							<el-menu-item index="1-1" @click="menu_index1"
								>固定资产</el-menu-item
							>
							<el-menu-item index="1-2" @click="menu_index2"
								>无形资产</el-menu-item
							>
							<el-menu-item index="1-3" @click="menu_index3"
								>资本化管理</el-menu-item
							>
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="2">
						<template slot="title">物料管理</template>
						<el-menu-item-group>
							<el-menu-item index="2-1" @click="menu_index4"
								>材料管理</el-menu-item
							>
							<el-menu-item index="2-2" @click="menu_index5"
								>燃料管理</el-menu-item
							>
							<el-menu-item index="2-3" @click="menu_index6"
								>动力管理</el-menu-item
							>
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="3">
						<template slot="title">凭证管理</template>
						<el-menu-item-group>
							<el-menu-item index="3-1" @click="menu_index7"
								>凭证列表</el-menu-item
							>
						</el-menu-item-group>
					</el-submenu>
				</el-menu>
			</el-aside>
			<el-main style="padding:0 0 0 20px;">
				<gudinzc
					v-if="indexs === 1"
					:projectId="projectId"
					:type="type"
					ref="gudinzc"
				></gudinzc>
				<wuxingzc
					v-if="indexs === 2"
					:projectId="projectId"
					:type="type"
				></wuxingzc>
				<zibenhua
					v-if="indexs === 3"
					:projectId="projectId"
					:type="type"
				></zibenhua>
				<cailiaogl
					v-if="indexs === 4"
					:projectId="projectId"
					:type="type"
				></cailiaogl>
				<ranliaogl
					v-if="indexs === 5"
					:projectId="projectId"
					:type="type"
				></ranliaogl>
				<dongligl
					v-if="indexs === 6"
					:projectId="projectId"
					:type="type"
				></dongligl>
				<voucher
					v-if="indexs === 7"
					:projectId="projectId"
					:type="type"
				></voucher>
			</el-main>
		</el-container>
	</div>
</template>

<script>
import gudinzc from "./modules/finances/gudinzc";
import wuxingzc from "./modules/finances/wuxingzc";
import zibenhua from "./modules/finances/zibenhua";
import cailiaogl from "./modules/finances/cailiaogl";
import ranliaogl from "./modules/finances/ranliaogl";
import dongligl from "./modules/finances/dongligl";
import voucher from "./modules/finances/voucher";

export default {
	props: {
		projectId: {
			type: String,
			default: ""
		},
		type: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			indexs: 1,
			indexss: "1-1"
		};
	},
	created() {},
	methods: {
		qh() {
			this.indexs = 1;
			this.indexss = "1-1";
			this.$refs.elMenu.activeIndex = "1-1";
			this.$refs["gudinzc"].resetQuery();
		},
		menu_index1() {
			this.indexs = 1;
		},
		menu_index2() {
			this.indexs = 2;
		},
		menu_index3() {
			this.indexs = 3;
		},
		menu_index4() {
			this.indexs = 4;
		},
		menu_index5() {
			this.indexs = 5;
		},
		menu_index6() {
			this.indexs = 6;
		},
		menu_index7() {
			this.indexs = 7;
		},
		getNavType() {
			this.indexss = this.$store.state.indexss;
		}
	},
	components: {
		gudinzc,
		wuxingzc,
		zibenhua,
		cailiaogl,
		ranliaogl,
		dongligl,
		voucher
	},
	watch: {
		// 监测store.state
		"$store.state.adminleftnavnum": "getNavType"
	}
};
</script>

<style scoped>
.index-con >>> .el-menu-item-group__title {
	padding: 0 !important;
}
</style>
